import React from 'react';
import FieldErrors from '../ErrorComponents/FieldErrors/FieldErrors';
import HelperText from './HelperText';

export default class PasswordInput extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			icon,
			id,
			name,
			style,
			placeholder,
			value,
			onChange,
			helperText,
			fieldErrors
		} = this.props;

		return (
			// console.log('PasswordInput', this.props),
			<div className="PasswordInput mt-1 mb-4">
				<span className={icon} style={{ fontSize: 16, top: 10, left: 13 }} />
				<input
					type="password"
					autoCapitalize="off"
					autoComplete="off"
					className={`${this.props
						.tailwindStyles} block border border-gray-300 w-full p-2 px-3 h-10 rounded ${icon
						? 'has-icon'
						: ''}`}
					id={id}
					name={name}
					style={style}
					placeholder={placeholder}
					value={value || ''}
					onChange={onChange}
				/>
				<div className="p-1">
					{fieldErrors && fieldErrors.hasOwnProperty(name) ? (
						<FieldErrors fieldName={name} fieldErrors={fieldErrors} />
					) : (
						<HelperText>{helperText}</HelperText>
					)}
				</div>
			</div>
		);
	}
}
